import React from 'react'
import { Field as FormikField } from 'formik'
import styled from 'styled-components/macro'

import { Input } from './Input'

export default function Field({
  name,
  label,
  type,
  placeholder,
  isOptional,
  onChange = undefined,
}) {
  return (
    <FormikField name={name}>
      {({ field, meta }) => (
        <StyledField>
          {type !== 'checkbox' && (
            <label htmlFor={name}>
              {label}
              {isOptional && <span> (facoltativo)</span>}
            </label>
          )}
          {type === 'file' ? (
            <Input
              id={name}
              type={type}
              placeholder={placeholder}
              onChange={onChange}
              name={field.name}
            />
          ) : (
            <Input id={name} type={type} placeholder={placeholder} {...field} />
          )}
          {type === 'checkbox' && <span></span>}
          {type === 'checkbox' && (
            <label htmlFor={name}>
              {label}
              {isOptional && <span> (facoltativo)</span>}
            </label>
          )}
          {meta.touched && meta.error && <p>{meta.error}</p>}
        </StyledField>
      )}
    </FormikField>
  )
}

export const StyledField = styled.div`
  margin-bottom: 24px;
  position: relative;

  &:last-of-type {
    margin-bottom: 0;
  }

  > label {
    display: block;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 12px;
    line-height: 1;
    font-weight: 700;
    text-transform: uppercase;
    margin-bottom: 6px;

    span {
      color: #a1a1a1;
      font-weight: 500;
      text-transform: none;
    }
  }
  > span {
    position: absolute;
    border: 1px solid #000;
    width: 20px;
    height: 20px;
    left: 0;
    top: 0;
  }
  input[type='checkbox'] {
    opacity: 0;
    position: absolute;
    left: 0;
    top: 0;
    height: 30px;
    width: 100%;
    z-index: 2;
  }
  > input[type='checkbox']:checked + span::before {
    content: '';
    position: absolute;
    top: 4px;
    left: 3px;
    width: 12px;
    height: 5px;
    background: transparent;
    border: 1px solid #000;
    border-top: none;
    border-right: none;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  > input[type='checkbox'] ~ label {
    padding-left: 30px;
    margin-bottom: 0;
    line-height: 20px;
  }

  > p {
    color: #cc0000;
    font-size: 14px;
    margin-top: 3px;
  }
`
